/** @module wgfractals/util/bindgroup */
import { getDevice } from "../init.mjs";

// Every fractal shader binds exactly two resources, at 0/1 (output buffer, params).

/**
 * Creates a `GPUBindGroup` by mapping each buffer to sequential binding indices
 * (0, 1, …). The order of `buffers` must match the `@binding`s declared in the shader.
 * @param {GPUBindGroupLayout} layout - from `pipeline.getBindGroupLayout(0)`; the layout is derived automatically from the shader because pipelines are compiled with `layout: "auto"`
 * @param {GPUBuffer[]} buffers - buffers in binding order
 * @returns {GPUBindGroup}
 */
export function createBindGroup(layout, buffers) {
  const device = getDevice();
  const entries = buffers.map((buffer, i) => ({
    binding: i,
    resource: { buffer },
  }));
  return device.createBindGroup({ layout, entries });
}
